/**
 * Block-for-block skeleton for /billing/school (Plan 14).
 *
 * Mirrors the live page layout: chip strip (when org-level) +
 * 4-card aging strip + invoice table.
 *
 * Per the apps/ordo Loading-state convention (`@ordo/ui/skeleton`,
 * never a `Loading…` text fallback), this renders the same DOM
 * structure as `SchoolARPage` so the swap is imperceptible.
 */

import { Card, CardContent, CardHeader } from '@ordo/ui/card'
import { Skeleton } from '@ordo/ui/skeleton'

export function BillingSchoolSkeleton() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true" aria-label="Loading School AR">
      {/* Optional filter-chip strip — render 3 pills so the layout shifts predictably. */}
      <div className="flex flex-wrap items-center gap-2">
        <Skeleton className="h-7 w-24 rounded-full" />
        <Skeleton className="h-7 w-32 rounded-full" />
        <Skeleton className="h-7 w-36 rounded-full" />
      </div>

      {/* Aging cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i} className="p-4">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-8 w-28" />
              <Skeleton className="h-3 w-24" />
            </div>
          </Card>
        ))}
      </div>

      {/* Invoice table */}
      <Card>
        <CardHeader className="flex flex-col gap-2">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3 w-64" />
        </CardHeader>
        <CardContent>
          <div className="flex flex-col gap-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <InvoiceRowSkeleton key={i} />
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

function InvoiceRowSkeleton() {
  return (
    <div className="flex items-center gap-3 border-b pb-3 last:border-b-0">
      <Skeleton className="h-6 w-16 rounded-full" />
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-4 w-24" />
      <div className="flex-1" />
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-8 w-8 rounded-md" />
    </div>
  )
}
